/**
 * How the API's `FlexibleFloat` scalar reads an input. Text that `Number`
 * reads as a number (including "1e-5") becomes one; anything else is kept as
 * given so validation can reject it by name.
 *
 * Shared so a form can hold exactly the values the validator accepted.
 */
export function parseFlexibleFloat(value: unknown): unknown {
  if (value == null) return null;
  if (typeof value !== "string") return value;

  const trimmed = value.trim();
  if (trimmed === "") return value;

  // ast-grep-ignore: no-unsafe-number-parsing
  const parsed = Number(trimmed);
  return Number.isNaN(parsed) ? value : parsed;
}
